import { useQuery } from '@tanstack/react-query';
import { AwardsService } from '../services';
import { awardsKeys } from '../queryKeys';

/**
 * Every review written about one member in a cycle.
 *
 * Received, never given. An empty list means nobody has reviewed them yet,
 * which is an ordinary state and not an error — callers render an empty state
 * for it and reserve their failure branch for `isError`.
 */
export const useMemberReceivedFeedback = (cycleId, userId) => {
  const { data, isPending, isError } = useQuery({
    queryKey: awardsKeys.memberReceivedFeedback(cycleId, userId),
    queryFn: () => AwardsService.getMemberReceivedFeedback(cycleId, userId),
    enabled: Boolean(cycleId && userId),
    retry: false,
  });

  return { feedback: data ?? [], isPending, isError };
};
